module.exports = __webpack_public_path__ + "../static/img/standard_devices.1b774310.png";